export enum SiteSubmitButtonText {
  DONE = 'Done',
  CANCEL = 'Cancel',
  NEXT = 'Next',
  UPLOADING = 'Uploading',
  PROCESSING = 'Processing',
  ADD_SITE = 'Add Site',
  UPDATE_SITE = 'Update Site',
}

export enum AccessType {
  Basic = 'basic',
  RestrictedIterationData = 'restricted_iteration_data',
  RestrictedSiteData = 'restricted_site_data',
}

export const TAG_BASED_ACCESS_TYPES = new Set([
  AccessType.RestrictedIterationData,
  AccessType.RestrictedSiteData,
]);
